import { logger } from 'src/Utils/LoggerService/LoggerService';
import { useTranslation } from 'react-i18next';
import './Document.css';
import LineSeparation from 'src/SharedComponents/LineSeparation/LineSeparation';
interface ITechDocGrid {
    title: string;
    image?: string;
    fileLink:string;
    duration?: string;
}
const Document: React.FC<ITechDocGrid> = ({ title, image, fileLink, duration }) => {
    const { t } = useTranslation();
    return (
        <div>
            <div className='me-3'>
                <div className='row d-flex mt-4 document'>
                    <div className='mx-2 my-2'>
                        <div className="m-1">
                            <span className='document-header row'>
                                <div className={`document-title ${duration ? 'col-md-10' : 'col-md-12'}`} title={t(title)}>
                                    {t(title)}
                                </div>
                                {duration && (
                                    <div className='extra-text-right col-2 d-flex justify-content-end'>
                                        {duration}
                                    </div>
                                )}
                            </span>
                        </div>

                        <LineSeparation />
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', borderRadius: '25px', marginTop: '4px' }}
                             onClick={() => { logger.logInformation(`User downloaded file with name: "${title}".`) }}>
                            <a
                                href={fileLink}
                                target="_blank"
                                rel="noOpener noReferrer"
                                style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '8px 20px 16px 8px' }}>
                                {/* No object-fit: the preview sets its own height. A fixed-height box cropped these wide previews (the wordmark) at narrower card widths. */}
                                <img src={image} alt="Technical document" style={{ cursor: 'pointer', width: '100%', height: 'auto', display: 'block', borderRadius: '16px' }} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Document